module.exports = __webpack_public_path__ + "img/vision_01.c0147cfc.webp";